import * as React from 'react';

export const Tags: React.FC<{ value: string[] }> = ({ value }) => <>{value.length === 0 ? 'none' : value.join(', ')}</>;
